<template>
  
</template>

<script>
export default {
  name: "PaymentResFlutterWave",
  components: {},
  beforeCreate() {
    this.packages = this.$store.state.packages;
    this.$store.dispatch("account").then((res) => {
				if (res) {
					this.data = res.response;
					this.$store.commit("setLoader", false);
				}
			});
  },
created(){
this.doSubscribe()
},
  methods: {
    doSubscribe() {
      this.$store.commit("setLoader", true);
      this.$store.dispatch("FlutterWaveVerifyPayment", {
        tx_ref: this.$route.query.tx_ref,
        })
        .then((response) => {
          this.$store.commit("setLoader", false);
          this.$store.commit(
            "setNotification",
            " Subscription Added Sucessfully !! "
          );
          this.$router.push("/home");
        })
        .catch((err) => {
          this.$store.commit("setLoader", false);
          this.$store.commit(
            "setNotification",
            " Error Occured Please try again  "
          );
          //this.$router.push("/login");
        });
    },
   
    
  },

   
  data() {
    return {
		data: null,
      checked: false,
	  currentSubs: null,
 	currentpackages: null,
    };
  },
};
</script>
<style scoped>
.py-5 {
  padding-top: 8rem !important;
  padding-bottom: 8rem !important;
  min-height: 100vh !important;
}
</style>
